

export const ProductsTitleSection=()=>{
    
    
    return(
        <div className="products-title">
            <div className="__container">
                <div className="products-title_row">
                    <div className="products-title_lobster">
                        <img src={require('../../../../static/IMAGE-products-title-left.png')}/>
                    </div>
                    <div className='products-title_title'>
                        <p>THROW SOME LAVA IN YOUR JAVA</p>
                        </div>
                    <div className="products-title_lobster">
                        <img src={require('../../../../static/IMAGE-products-title-right.png')}/>
                    </div>
                </div>
            </div>
        </div>
    )
}